import { cn } from "@/lib/utils";

type InfoCardProps = {
  title: string;
  tag?: string;
  description: string;
  className?: string;
};

export function InfoCard({ title, tag, description, className }: InfoCardProps) {
  return (
    <div
      className={cn(
        "rounded-lg border border-border/60 bg-card px-6 py-6 transition-colors hover:bg-muted/15",
        className,
      )}
    >
      <div className="flex items-center gap-3">
        <h3 className="text-base font-medium text-foreground">{title}</h3>
        {tag != null && (
          <span className="rounded-full border border-border/60 bg-muted/30 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            {tag}
          </span>
        )}
      </div>
      <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{description}</p>
    </div>
  );
}
